import { makeStyles } from 'tss-react/mui';

import { isLightTheme, premiumBackground } from 'uiKit/Theme/themeUtils';

import { HEADER_HEIGHT } from '../Header';
import { MOBILE_HEADER_HEIGHT } from '../MobileHeader';
import { SIDEBAR_WIDTH } from '../SideBar';

export interface IUseDefaultLayoutStylesProps {
  hasGradient?: boolean;
  topBannersHeight: number;
}

const name = 'DefaultLayout';

export const useDefaultLayoutStyles = makeStyles<IUseDefaultLayoutStylesProps>({
  name,
})((theme, { hasGradient, topBannersHeight }) => ({
  root: {
    display: 'flex',

    minHeight: '100%',
    minWidth: 375,
    paddingTop: topBannersHeight,

    background: theme.palette.background.default,
  },
  sidebar: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'column',

    width: '100%',
    paddingTop: HEADER_HEIGHT,
    paddingLeft: SIDEBAR_WIDTH,

    background:
      hasGradient && isLightTheme(theme)
        ? premiumBackground
        : theme.palette.background.default,

    [theme.breakpoints.down('md')]: {
      paddingTop: MOBILE_HEADER_HEIGHT,
      paddingLeft: 0,
    },
  },
  header: {
    zIndex: 2,
    '&&': {
      backgroundColor: `${theme.palette.background.default} !important`,
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
  mobileHeader: {
    display: 'none',

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      borderBottom: `0.5px solid ${theme.palette.divider}`,
    },
  },
}));
